module.exports = __webpack_public_path__ + "img/product-five-1.fda9b8fb.png";